import { render, staticRenderFns } from "./BurialSearchResult.vue?vue&type=template&id=1cabbbc6&scoped=true"
import script from "./BurialSearchResult.vue?vue&type=script&lang=js"
export * from "./BurialSearchResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cabbbc6",
  null
  
)

export default component.exports